import Spinner from '/home/msuser1/dinesh/workSpace/react/first-app/src/components/Spinner.jsx'
import IdCard from '/home/msuser1/dinesh/workSpace/react/first-app/src/components/Idcard.jsx'


const Contact = () => {
  return <>
     {/* <h1>Contact to : react.timer@gmail.com </h1>
     <Spinner/> */}
      <IdCard/>
  </>
};

export default Contact;